import { getPlainText } from "@/utils/articleHtmlSplit";
import Head from "next/head";

const BreadcrumbSchema = ({ breadcrumbList = [] }) => {
  // console.log("breadcrumbList", breadcrumbList);
  let itemList = [
    {
      "@type": "ListItem",
      position: 1,
      item: {
        name: "Home",
        "@id": `${process.env.NEXT_PUBLIC_WEBSITE_URL}`,
        // "@id": `${process.env.NEXT_PUBLIC_WEBSITE_URL}`,
      },
    },
  ];

  if (breadcrumbList.length > 0) {
    breadcrumbList.map((item, index) => {
      const isLast = index === breadcrumbList.length - 1;

      const listItem = {
        "@type": "ListItem",
        position: index + 2,
        item: {
          name: getPlainText(item?.title),
        },
      };

      if (!isLast) {
        listItem.item["@id"] = item?.canonical_url?.includes(
          process.env.NEXT_PUBLIC_WEBSITE_URL
        )
          ? `${item?.canonical_url}`
          : process.env.NEXT_PUBLIC_WEBSITE_URL + `${item?.canonical_url}`;
      }

      itemList.push(listItem);
    });
  }

  // console.log("breadcrumbList 2", itemList);
  return (
    <Head>
      <script
        id="BreadcrumbSchema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: itemList,
          }),
        }}
      />
    </Head>
  );
};

export default BreadcrumbSchema;
